import { createStore } from "redux";
import { filterreducerFunction } from './states/filterState';
import { combineReducers } from 'redux';
import { chartreducerFunction } from './states/chartState';
import { displayModereducerFunction } from "./states/displayModeState";
import { appGlobalReducerFunction } from "./states/appGlobalState";

const reducers = {
    filter: filterreducerFunction,
    chart: chartreducerFunction,
    displayMode: displayModereducerFunction,
    appGlobal: appGlobalReducerFunction
}

let _reducers = combineReducers({...reducers});
export const store = createStore(_reducers);
